'use client';

import PriorityImage from '@/components/PriorityImage/PriorityImage';
import { MembershipTierWithTrial } from '@/lib/constants/maverick';

export interface WhatsIncludedProps {
  tier: MembershipTierWithTrial;
  logoUrl: string;
  description: string;
  url: string;
}

// Content is coming from Contentful, thus should already be translated
export function WhatsIncludedTile({
  tier,
  logoUrl,
  description,
  url,
}: WhatsIncludedProps): JSX.Element {
  return (
    <div className='flex justify-center md:w-full lg:text-center'>
      <div className='max-w-[400px] md:w-full md:max-w-screen-lg'>
        <div className='rounded-3xl bg-white px-4 py-8 md:flex md:items-center md:justify-between md:gap-24 md:p-16'>
          <div className='order-1 flex justify-center md:order-2 md:w-1/2'>
            <div className='md:w-full md:max-w-[450px]'>
              <div className='mb-3'>
                <PriorityImage
                  src={logoUrl}
                  alt={`membership-tier-card-image-${tier}`}
                  className='h-5'
                  testId={`whats-included-logo-${tier}`}
                ></PriorityImage>
              </div>
              <p className='pb-8 text-center md:pb-0'>{description}</p>
            </div>
          </div>
          <img
            className='order-2 md:order-1 md:w-1/2 md:rounded-3xl'
            data-testid='whats-included-image'
            src={url}
            alt={tier}
          />
        </div>
      </div>
    </div>
  );
}
